import { AbstractIntlMessages } from 'next-intl';

import { defaultLocale, LocaleType, locales } from '@/shared/lib/i18n';

import en from './locales/en-US.json';
import ko from './locales/ko-KR.json';
import zhCN from './locales/zh-CN.json';
// import zhTW from './locales/zh-TW.json';

export const messages: Record<LocaleType, AbstractIntlMessages> = {
  // temporary modify for commit
  'ko-KR': ko as unknown as AbstractIntlMessages,
  'en-US': en as unknown as AbstractIntlMessages,
  'zh-CN': zhCN as unknown as AbstractIntlMessages,
  // 'zh-TW': zhTW as unknown as AbstractIntlMessages,
};

export const languages: { label: string; value: LocaleType }[] = [
  { label: 'KOREAN', value: 'ko-KR' },
  { label: 'ENGLISH', value: 'en-US' },
  { label: '中文(简体)', value: 'zh-CN' },
  // { label: '中文(繁體)', value: 'zh-TW' },
] as const;

export const i18nConfig = {
  defaultLocale,
  locales,
  timeZone: 'Asia/Seoul',
} as const;
